import { render, staticRenderFns } from "./CustomerNewPassword.vue?vue&type=template&id=168a9db2&"
import script from "./CustomerNewPassword.vue?vue&type=script&lang=js&"
export * from "./CustomerNewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports